import { notifyToast } from "@/components/portal";
import { authAdapter } from "@/core/auth/adapter";
import type { CombinedError, Operation } from "urql";

const GRAPHQL_ERROR_TITLE = "Terjadi kesalahan";
const UNKNOWN_ERROR_MESSAGE = "Terjadi kesalahan. Coba lagi.";
const NETWORK_ERROR_MESSAGE = "Koneksi bermasalah. Coba lagi.";
const NULL_SCHEMA_MARKER =
	"the requested element is null which the schema does not allow";

// Caller shows its own error.
export const SKIP_ERROR_TOAST_CONTEXT = { skipErrorToast: true } as const;

type ExtensionErrors = { message?: string }[] | undefined;

export const extractGraphQLErrorMessage = (error: CombinedError): string =>
	(error.graphQLErrors?.[0]?.extensions?.errors as ExtensionErrors)?.[0]
		?.message ??
	error.graphQLErrors?.[0]?.message ??
	error.message ??
	UNKNOWN_ERROR_MESSAGE;

export const toastGraphQLError = (
	error: CombinedError,
	operation: Operation,
) => {
	const message = extractGraphQLErrorMessage(error);
	const isToastSkipped =
		operation.context.skipErrorToast === true ||
		authAdapter.isExpiredTokenMessage(message);
	if (isToastSkipped) return;
	const isNullSchemaError = message.includes(NULL_SCHEMA_MARKER);
	notifyToast({
		tone: "err",
		title: GRAPHQL_ERROR_TITLE,
		text: error.networkError
			? NETWORK_ERROR_MESSAGE
			: isNullSchemaError
				? UNKNOWN_ERROR_MESSAGE
				: message,
	});
};
